import React from 'react';
import ReactDOM from 'react-dom';

import Select from 'react-select';
import ProductSelect from '../product-select/product-select.js';
import RatingSelect from '../rating-select/rating-select.js';
import MultiSelect from '../multi-select/multi-select.js';
import DateRangePicker from '../jqdatepicker/reactwrapper.js'
import classNames from 'classnames';
import {deepCopy}  from '../util.js';

import './filter.css';

class FeedCheckFilter extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            hiddenInputs:[],
            extended: false,
            changed: 0, // number of filter changed (non default values)
            recentChanges: 0, 
            initialChanged: 0, // used for highlight the apply filters button
            applied: 0,
            productItemName: this.props.productItemName || "Product"
        }
        this.formRef = React.createRef();

        /*
        filter model:
        
        default - the value of the filter when filter is not applied
        initial - the value when filter is initialized. This value is not changed after initialization
        current - the current value. This value is changing during user interaction
        */

        this.filters = {
            product: {
                name: 'product',
                enabled: true,
                default: deepCopy(this.props.productDefault),
                current: deepCopy(this.props.product),
                initial: deepCopy(this.props.product),
                changed: false,
                options: this.props.productOptions
            },
            comparedProduct: {
                name: 'compared-product',
                enabled: this.props.comparedProductEnable || false,
                default: deepCopy(this.props.comparedProductDefault || {value:"", label:""}),
                current: deepCopy(this.props.comparedProduct || {value:"", label:""}),
                initial: deepCopy(this.props.comparedProduct || {value:"", label:""}),
                changed: false,
                options: this.props.comparedProductOptions
            },
            ratings: {
                name: 'ratings',
                enabled: true,
                default: deepCopy(this.props.ratingsDefault),
                current: deepCopy(this.props.ratings),
                initial: deepCopy(this.props.ratings),
                changed: false
            },
            date: {
                name: 'data_range',
                enabled: true,
                default: deepCopy(this.props.dateDefault),
                current: deepCopy(this.props.date),
                initial: deepCopy(this.props.date),
                changed: false
            },
            channel: {
                name: 'channel',
                enabled: true,
                default: deepCopy(this.props.channelDefault),
                current: deepCopy(this.props.channel),
                initial: deepCopy(this.props.channel),
                changed: false,
                options: this.props.channelOptions
            },
            status: {
                name: 'status',
                enabled: true,
                default: deepCopy(this.props.statusDefault),
                current: deepCopy(this.props.status),
                initial: deepCopy(this.props.status),
                changed: false,
                options: this.props.statusOptions
            },
            language: {
                name: 'language',
                enabled: this.props.languageEnable,
                default: deepCopy(this.props.languageDefault),
                current: deepCopy(this.props.language),
                initial: deepCopy(this.props.language),
                changed: false,
                options: this.props.languageOptions
            },
            content: {
                name: 'content',
                enabled: true,
                default: deepCopy(this.props.contentDefault),
                current: deepCopy(this.props.content),
                initial: deepCopy(this.props.content),
                changed: false,
                options: this.props.contentOptions
            }
        }

        this.filterChange = this.filterChange.bind(this)
        this.computeFilterState = this.computeFilterState.bind(this)
        this.ping = this.ping.bind(this)
        this.setHiddenInputs = this.setHiddenInputs.bind(this)
        this.toggle = this.toggle.bind(this)
        this.openAllFilters = this.openAllFilters.bind(this)
        this.clearFilters = this.clearFilters.bind(this)
        this.submitForm = this.submitForm.bind(this)
    }

    openAllFilters() {
        this.setState({extended:true})
    }
    
    toggle() {
        this.setState({extended:!this.state.extended})
    }

    ping() {
        console.log("ping")
    }

    setHiddenInputs(inputs, submit=false) {
        // input is an array containing objects with value and name property
        var hiddenInputs = this.state.hiddenInputs;

        // merge arrays and overwrite elements with the same name
        inputs.forEach((item) => {
            var found = false;
            for(var i=0; i<hiddenInputs.length; i++){
                if(hiddenInputs[i].name == item.name){
                    // overwrite existing item
                    hiddenInputs[i] = item
                    found = true;
                }
            }
            if(!found){
                hiddenInputs.push(item);
            }
        })

        this.setState({
            hiddenInputs: hiddenInputs,
            recentChanges: this.state.recentChanges + 1
        })

        if(submit) {
            setTimeout(() => {this.formRef.current.submit()}, 100)
        }
    }

    componentDidMount() {
        this.computeFilterState();
    }

    computeFilterState() {
        var changed = 0; // default vs current changes
        var initialChanged = 0; // initial vs current
        var applied = 0; // initial vs default

        for (var [key, value] of Object.entries(this.filters)) {
            if (!value.enabled){
                continue
            }

            // compute the difference between default and current values of the filters
            if (JSON.stringify(value.default) != JSON.stringify(value.current)) {
                value.changed= true;
                changed++;
            } else {
                value.changed = false;
            }

            // compute changed values, the difference between initial and current values of the filters
            if (JSON.stringify(value.initial) != JSON.stringify(value.current)) {
                initialChanged = true;
            }

            // compute changed & appied, the difference between initial and default values of the filters
            if (JSON.stringify(value.initial) != JSON.stringify(value.default)) {
                applied++;
            }
        }

        // console.log(this.filters);
        // Force a render without state change...
        // this.forceUpdate();
        
        this.setState({
            changed: changed,
            initialChanged: initialChanged,
            applied: applied
        })
    }

    filterChange(val, target) {
        this.filters[target].current = val
        this.setState({recentChanges: this.state.recentChanges + 1})
        this.computeFilterState()
    }

    submitForm() {
        this.formRef.current.submit()
    }

    clearFilters() {
        for (var [key, value] of Object.entries(this.filters)) {
            if (value.enabled){
                value.current = value.default
            }  
        }

        // we should open the filters in order to apply all values
        this.openAllFilters()

        this.computeFilterState()
        // send the form with a small delay in order to give time for the updates of the inputs behind the filters
        setTimeout(this.submitForm, 100)
    }

    render(){
        return (
            <div>
                <form method="get" ref={this.formRef} id="filter-form">

                    <div className='row'>
                        <div className='col-md-4'>
                            <div className={classNames('form-group', 'filter', this.filters.product.name,
                                {
                                    changed: this.filters.product.changed
                                })
                            }>
                                <label>{this.state.productItemName}:</label>
                                <ProductSelect 
                                    name={this.filters.product.name} 
                                    options={this.filters.product.options} 
                                    onChange={(val) => this.filterChange(val, 'product')}
                                    value={this.filters.product.current}
                                    externalValue={true} />
                            </div>

                            { this.state.extended && this.filters.comparedProduct.enabled ?
                                <div className={classNames('form-group', 'filter', this.filters.comparedProduct.name,
                                    {
                                        changed: this.filters.comparedProduct.changed
                                    })
                                }>
                                    <label>Compared {this.state.productItemName}:</label>
                                    <ProductSelect 
                                        name={this.filters.comparedProduct.name} 
                                        options={this.filters.comparedProduct.options} 
                                        onChange={(val) => this.filterChange(val, 'comparedProduct')} 
                                        value={this.filters.comparedProduct.current}
                                        externalValue={true} />
                                </div>
                                :null
                            }

                            { this.state.extended && this.filters.channel.enabled ?
                                <div className={classNames('form-group', 'filter', this.filters.channel.name,
                                    {
                                        changed: this.filters.channel.changed
                                    })
                                }>
                                    <label>Channels:</label>
                                    <MultiSelect 
                                        name={this.filters.channel.name} 
                                        options={this.filters.channel.options}  
                                        value={this.filters.channel.current}
                                        onChange={(val) => this.filterChange(val, 'channel')} 
                                        externalValue={true} />
                                </div>
                                :null
                            }

                            { this.state.extended && this.filters.language.enabled ?
                                <div className={classNames('form-group', 'filter', this.filters.language.name, 
                                    {
                                        changed: this.filters.language.changed
                                    })
                                }>
                                    <label>Language:</label>
                                    <Select 
                                        name={this.filters.language.name} 
                                        options={this.filters.language.options}  
                                        value={this.filters.language.current}
                                        onChange={(val) => this.filterChange(val, 'language')} />
                                </div>
                                :null
                            }
                        </div>

                        <div className='col-md-4'>
                            <div className={classNames('form-group', 'filter', this.filters.ratings.name, 
                                {
                                    changed: this.filters.ratings.changed
                                })
                            }>
                                <label>Rating:</label>
                                <RatingSelect 
                                    name={this.filters.ratings.name}  
                                    onChange={(val) => this.filterChange(val, 'ratings')}
                                    value={this.filters.ratings.current}
                                    externalValue={true} />
                            </div>

                            { this.state.extended ?
                                <div className={classNames('form-group', 'filter', this.filters.status.name, 
                                    {
                                        changed: this.filters.status.changed 
                                    })
                                }>
                                    <label>Status:</label>
                                    <Select 
                                        name={this.filters.status.name} 
                                        options={this.filters.status.options} 
                                        value={this.filters.status.current} 
                                        onChange={(val) => this.filterChange(val, 'status')} 
                                        isSearchable={true} 
                                        isClearable={false} />
                                </div>
                                :null
                            }
                        </div>

                        <div className='col-md-4'>
                            <div className={classNames('form-group', 'filter', this.filters.date.name, 
                                {
                                    changed: this.filters.date.changed 
                                })
                            }>
                                <label>Date:</label> 
                                <DateRangePicker
                                    name={this.filters.date.name} 
                                    onChange={(val) => this.filterChange(val, 'date')}
                                    value={this.filters.date.current} />
                            </div>

                            { this.state.extended ?
                                <div className={classNames('form-group', 'filter', this.filters.content.name, 
                                    {
                                        changed: this.filters.content.changed
                                    })
                                }>
                                    <label>Content:</label>
                                    <Select 
                                        name={this.filters.content.name} 
                                        options={this.filters.content.options} 
                                        value={this.filters.content.current} 
                                        onChange={(val) => this.filterChange(val, 'content')} 
                                        isSearchable={true} 
                                        isClearable={false} />
                                </div>
                                :null
                            }
                        </div>

                        {this.state.hiddenInputs.map(function(object, i){
                            return <input type="hidden" name={object.name} value={object.value} key={i} />;
                            })
                        }
                    </div>
                    <div className='row text-right'>
                        <div className='col-md-12'>
                            { this.state.changed > 0 ?
                                <span>
                                    <span id="changed-filters-number">
                                        {this.state.changed}
                                    </span>&nbsp;
                                    {this.state.changed==1 ? "filter" : "filters"} changed 
                                    &nbsp;
                                    <button type="button" className="btn" onClick={ this.clearFilters }>Clear filters</button>
                                </span>
                                :null
                            }
                            &nbsp;
                            <button type="submit" className={classNames('btn', {
                               'btn-primary': this.state.initialChanged > 0  
                            })}>Apply filters</button>
                            &nbsp;
                            { this.state.extended ? 
                                <button type="button" className="btn" onClick={ this.toggle }>Less filters</button> : 
                                <button type="button" className="btn" onClick={ this.toggle }>More filters</button>
                            }
                        </div>
                    </div>
                </form>
            </div>
        )
    }
};

export default FeedCheckFilter;